export default __webpack_public_path__ + "static/media/chat.5653476c.jfif";